import React from "react";
import { Link } from "react-router-dom";
import { path } from "./therapyPaths";

function TherapyFooter() {
    return (
        <footer className="demo-footer">
            <div className="demo-container">
                <div className="demo-footer-grid">
                    <div className="demo-footer-brand">
                        <div className="demo-footer-logo">Harbor Therapy</div>
                        <p>
                            A group practice offering individual and couples therapy
                            for adults in Brooklyn and across New York and New Jersey
                            via telehealth.
                        </p>
                    </div>

                    <div className="demo-footer-col">
                        <h5>Practice</h5>
                        <Link to={path("therapists")}>Therapists</Link>
                        <Link to={path("services")}>Services</Link>
                        <Link to={path("practice")}>The space</Link>
                        <Link to={path("booking")}>Book a session</Link>
                    </div>

                    <div className="demo-footer-col">
                        <h5>Information</h5>
                        <Link to={path("faq")}>FAQ</Link>
                        <Link to={path("policies")}>Policies</Link>
                        <a href="mailto:hello@harbortherapy.com">Contact</a>
                    </div>

                    <div className="demo-footer-col">
                        <h5>Office</h5>
                        <p className="demo-footer-text">
                            142 Montague Street, Suite 4B
                            <br />
                            Brooklyn, NY 11201
                            <br />
                            (718) 555-0142
                        </p>
                    </div>
                </div>

                <div className="demo-footer-bottom">
                    <p>
                        © {new Date().getFullYear()} Harbor Therapy, PLLC · A group
                        practice of independently licensed clinicians in NY and NJ
                    </p>
                    <p className="demo-footer-disclaimer">
                        If you are experiencing a mental health emergency, call 988
                        (Suicide &amp; Crisis Lifeline) or 911. This website does not
                        provide crisis services.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default TherapyFooter;